import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	SCHOLARSHIP_CATEGORY_FEATURE_KEY,
	ScholarshipCategoryState,
	ScholarshipCategoryPartialState,
	scholarshipCategoryAdapter
} from './scholarshipcategory.reducer';

// Lookup the 'ScholarshipCategory' feature state managed by NgRx
export const getScholarshipCategoryState = createFeatureSelector<
	ScholarshipCategoryPartialState,
	ScholarshipCategoryState
>(SCHOLARSHIP_CATEGORY_FEATURE_KEY);

const { selectAll, selectEntities } = scholarshipCategoryAdapter.getSelectors();

export const getScholarshipCategoryLoaded = createSelector(
	getScholarshipCategoryState,
	(state: ScholarshipCategoryState) => state.loaded
);

export const getScholarshipCategoryError = createSelector(
	getScholarshipCategoryState,
	(state: ScholarshipCategoryState) => state.error
);

export const loadingScholarshipCategory = createSelector(
	getScholarshipCategoryState,
	(state: ScholarshipCategoryState) => state.loaded
);

export const getAllScholarshipCategory = createSelector(
	getScholarshipCategoryState,
	(state: ScholarshipCategoryState) => selectAll(state)
);

export const getScholarshipCategoryEntities = createSelector(
	getScholarshipCategoryState,
	(state: ScholarshipCategoryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getScholarshipCategoryState,
	(state: ScholarshipCategoryState) => state.selectedScholarshipCategoryId
);

export const getSelected = createSelector(
	getScholarshipCategoryEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
